<!-- @format -->

<template>
  <div>
    <div class="client-container">
      <div
        class="cbg"
        :style="
          'background: url(' +
            partnerBackgroundUrl +
            ') center center; background-size: cover;'
        "
      ></div>
      <div class="cbgmenu"></div>
      <div class="ui twelve column padded grid centered">
        <div class="row">
          <div class="twelve wide column">
            <div>
              <h2>{{ results.fullName }}</h2>
              <div class="ui label" v-if="results.mobile">
                <i class="ui phone icon"></i> {{ results.mobile }}
              </div>
              <div class="ui label" v-if="results.primaryEmail">
                <i class="ui envelope outline icon"></i>
                {{ results.primaryEmail }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="twelve wide column">
            <div v-if="!newPlan" class="ui secondary pointing menu">
              <a
                class="ui item"
                v-bind:class="{ active: tab == 0 }"
                @click.prevent="tab = 0"
                >Key Info</a
              >
              <a
                class="ui item"
                v-bind:class="{ active: tab == 1 }"
                @click.prevent="tab = 1"
                >Goals</a
              >
              <a
                class="ui item"
                v-bind:class="{ active: tab == 2 }"
                @click.prevent="tab = 2"
                >Plans</a
              >
            </div>
            <div v-else class="ui secondary pointing menu"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui twelve column padded grid centered">
      <div v-if="false" class="row"></div>

      <div class="row">
        <div class="twelve wide column">
          <div class="ui attached padded text segment" v-if="newPlan">
            <NewGoalType :clientId="clientId" />
            <br />
            <div class="ui button" @click.prevent="showNewPlan(false)">
              Cancel
            </div>
          </div>
          <div v-else>
            <div v-if="tab == 0">
              <div class="twelve wide column">
                <div class="ui segment">
                  <sui-item-group>
                    <sui-item>
                      <sui-item-content>
                        <sui-item-description>
                          <sui-form>
                            <sui-form-field>
                              <label>First Name</label>

                              <sui-input
                                v-validate="'required'"
                                placeholder="First Name"
                                v-model="results.firstName"
                                name="First Name"
                                :disabled="disableForm"
                              />

                              <span
                                style="font-size: x-small; color: red"
                                v-show="errors.has('First Name')"
                              >
                                <sui-icon name="exclamation" />
                                {{ errors.first("First Name") }}
                              </span>
                            </sui-form-field>
                            <sui-form-field>
                              <label>Middle Name(s)</label>
                              <sui-input
                                placeholder="optional"
                                :disabled="disableForm"
                                v-model="results.middleNames"
                              />
                            </sui-form-field>
                            <sui-form-field>
                              <label>Last Name</label>
                              <sui-input
                                v-validate="'required'"
                                name="Last Name"
                                placeholder="Last Name"
                                v-model="results.lastName"
                                required
                                :disabled="disableForm"
                              />
                              <span
                                style="font-size: x-small; color: red"
                                v-show="errors.has('Last Name')"
                              >
                                <sui-icon name="exclamation" />
                                {{ errors.first("Last Name") }}
                              </span>
                            </sui-form-field>
                            <sui-form-field>
                              <label>Email</label>
                              <sui-input
                                v-validate="'required|email'"
                                name="Email"
                                placeholder="Email"
                                v-model="results.primaryEmail"
                                required
                                :disabled="disableForm"
                              />
                              <span
                                style="font-size: x-small; color: red"
                                v-show="errors.has('Email')"
                              >
                                <sui-icon name="exclamation" />
                                {{ errors.first("Email") }}
                              </span>
                            </sui-form-field>
                            <sui-form-field>
                              <label>Mobile</label>
                              <sui-input
                                v-validate="'required'"
                                name="Mobile"
                                placeholder="Mobile"
                                v-model="results.mobile"
                                :disabled="disableForm"
                              />
                            </sui-form-field>
                            <sui-form-field>
                              <label>Birthday</label>
                              <sui-input
                                v-validate="'required'"
                                name="Birthday"
                                placeholder="Birthday"
                                v-model="results.birthdaySk"
                                format
                                required
                                type="date"
                                :disabled="disableForm"
                              />
                              <span
                                style="font-size: x-small; color: red"
                                v-show="errors.has('Birthday')"
                              >
                                <sui-icon name="exclamation" />
                                {{ errors.first("Birthday") }}
                              </span>
                            </sui-form-field>
	                        
                          </sui-form>
                        </sui-item-description>
                      </sui-item-content>
                    </sui-item>
                  </sui-item-group>
                </div>
                <div class="ui padded segment message">
                  <sui-button
                    v-if="tab == 0"
                    v-show="disableForm"
                    @click.prevent="editClick"
                    type="submit"
                    class="primary"
                    >Edit</sui-button
                  >
                  <div
                    v-if="tab == 0"
                    v-show="!disableForm"
                    is="sui-button-group"
                  >
                    <sui-button @click.prevent="editClick">Cancel</sui-button>
                    <sui-button-or />
                    <sui-button
                      positive
                      v-show="!disableForm"
                      @click.prevent="saveClick"
                      >Save</sui-button
                    >
                  </div>
                </div>
                <div
                  v-show="message"
                  class="ui raised bottom success attached message"
                >
                  Successfully saved
                </div>
              </div>
            </div>
            <div v-if="tab == 1">
              <div v-if="!newPlan">
                <div class="ui attached message">
                  <span>
                    <span v-if="!loading"> #{{ goalsTotalRecords }} Goals</span>

                    <div
                      class="hollow-dots-spinner"
                      v-if="loading"
                      :style="spinnerStyle"
                    >
                      <div class="dot"></div>
                      <div class="dot"></div>
                      <div class="dot"></div></div
                  ></span>
                </div>
                <div v-if="goals.length > 0">
                  <div class="ui attached segment">
                    <div
                      class="ui divided items"
                      v-if="goalViewType == 'items'"
                      v-for="(pl, index) in goals"
                    >
                      <div class="ui item">
                        <div
                          :class="
                            'ui mini image animated rotate-vert-center ' +
                              ('delay-' + (index + 1))
                          "
                        >
                          <img :src="pl.goalPictureUrl" />
                        </div>
                        <div class="content">
                          <router-link
                            style="font-size: large"
                            :class="
                              ' animated fadeInRight ' + ('delay-' + index)
                            "
                            :to="
                              '/v2/client/' + pl.clientId + '/goals/' + pl.id
                            "
                            >{{
                              pl.requestObject.goalInfo.goalName
                            }}</router-link
                          >

                          <div class="meta">
                            <span class="cinema">
                              allocated to
                              <strong>{{
                                pl.requestObject.accounts[0].portfolios[0]
                                  .portfolio.portfolioName
                              }}</strong>
                            </span>
                            <br />
                          </div>

                          <div class="extra">
                            <sui-dropdown
                              text="Action"
                              class="ui label"
                              tiny
                              button
                              pointing
                            >
                              <sui-dropdown-menu>
                                <sui-dropdown-item
                                  @click.prevent="
                                    deleteGoal(pl.clientId, pl.id)
                                  "
                                  >Delete</sui-dropdown-item
                                >
                              </sui-dropdown-menu>
                            </sui-dropdown>
                            <br />
                            <small
                              >Last updated:
                              {{ friendlyDate(pl.updatedAsAt) }}</small
                            >
                          </div>
                        </div>
                      </div>
                      <div v-if="appearanceSettings">
                        {{ appearanceSettings }}
                        <ChartProjectedBalancesMini
                          style="
                            font-size: 1.3em;
                            font-weight: bold;
                            color: black;
                            opacity: 0.5;
                            margin-left: 230px;
                            margin-top: -100px;
                            position: absolute;
                          "
                          :appearanceSettings="appearanceSettings"
                          :chartProjections="pl.responseObject.projections"
                          :projectionRequest="pl.requestObject"
                          :adjustForInflation="false"
                          :showLowestProjectedOutcome="false"
                          :show="true"
                          v-show="true"
                        />
                      </div>
                      <div
                        v-if="index < goals.length - 1"
                        class="ui divider"
                      ></div>
                    </div>
                    <div v-if="goalViewType == 'charts'" class="ui four cards">
                      <div class="ui card" v-for="(g, index) in goals">
                        <div class="content" style="max-height: 50px">
                          <div class="ui avatar image">
                            <img :src="g.goalPictureUrl" />
                          </div>
                          <router-link
                            :class="
                              ' animated fadeInRight ' + ('delay-' + index)
                            "
                            :to="'/v2/client/' + g.clientId + '/goals/' + g.id"
                          >
                            {{ g.requestObject.goalInfo.type }}</router-link
                          >
                        </div>
                        <div class="ui image">
                          <ChartProjectedBalancesMini
                            :index="index"
                            :colors="colors[1]"
                            :chartProjections="g.responseObject.projections"
                            :projectionRequest="g.requestObject"
                            :adjustForInflation="false"
                            :showLowestProjectedOutcome="false"
                            :show="true"
                          />
                        </div>
                        <div class="ui content">
                          <div class="description" style="font-size: 0.9em">
                            allocated to
                            <strong>
                              {{
                                g.requestObject.accounts[0].portfolios[0]
                                  .portfolio.portfolioName
                              }}</strong
                            >
                          </div>
                          <table
                            class="ui very basic very compact table"
                            style="font-size: 0.9em"
                          >
                            <tr>
                              <td>Risk Profile</td>
                              <td>
                                {{
                                  g.requestObject.goalRiskProfile
                                    .getGoalRiskProfileResponse.riskProfile
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Market Value</td>
                              <td>
                                {{ g.requestObject.goalInfo.currency }}
                                {{
                                  formatNr(
                                    g.requestObject.accounts[0]
                                      .accountMarketValue
                                  )
                                }}
                              </td>
                            </tr>
                          </table>
                        </div>

                        <div class="extra content">
                          <sui-dropdown
                            text="Action"
                            class="ui label"
                            tiny
                            button
                            pointing
                          >
                            <sui-dropdown-menu>
                              <sui-dropdown-item
                                @click.prevent="deleteGoal(g.clientId, g.id)"
                                >Delete</sui-dropdown-item
                              >
                            </sui-dropdown-menu>
                          </sui-dropdown>
                        </div>
                        <div class="extra content">
                          <small
                            >Last updated:
                            {{ friendlyDate(g.updatedAsAt) }}</small
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ui attached message">
                    <span>
                      <div
                        class="ui large primary button"
                        @click.prevent="showNewPlan(true)"
                      >
                        Create New Goal
                      </div>
                    </span>
                    <span style="float: right">
                      <a
                        class="ui simple button"
                        v-if="pageNr > 1"
                        @click.prevent="getResults(pageNr - 1)"
                      >
                        <i class="ui chevron left icon"></i> Previous Page
                      </a>

                      <a
                        class="ui simple button"
                        v-if="goalsTotalPages > pageNr"
                        @click.prevent="getResults(pageNr + 1)"
                      >
                        <i class="ui chevron right icon"></i> Next Page
                      </a>
                    </span>
                  </div>
                </div>
                <span v-else>
                  No goals created yet.
                  <br />
                  <div class="ui divider"></div>
                  <span>
                    <div
                      class="ui large primary button"
                      @click.prevent="showNewPlan(true)"
                    >
                      Create New Goal
                    </div>
                  </span>
                </span>
              </div>
            </div>
            <div v-if="tab == 2">
              <ClientProposalsV2 />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import numeral from "numeral";
import moment from "moment";
// @ is an alias to /src
import {
  getClient,
  createClient,
  getClientGoalsV2,
  createProposalsV2,
  deleteClientGoalsV2,
  getPartnerSettings,
} from "@/gateway";
import NewGoalType from "@/components/NewGoalTypeV22";
import ChartProjectedBalancesMini from "@/components/ChartProjectedBalancesV2Mini";
import ClientProposalsV2 from "@/components/ClientProposalsV2";
export default {
  name: "home",
  components: { NewGoalType, ClientProposalsV2, ChartProjectedBalancesMini },
  computed: {
    partnerBackgroundUrl() {
      if (this.$store.state.partnerBackgroundUrl)
        return this.$store.state.partnerBackgroundUrl;
      else return "";
    },
    newPlansOfProposal() {
      let planss = [];

      for (var i = 0; i < this.goals.length; i++) {
        if (this.goals[i].addToPlan == true) planss.push(this.goals[i].id);
      }
      return planss;
    },
  },
  data() {
    return {
      appearanceSettings: {},
      pageNr: 1,
      goalsTotalRecords: 1,
      goalsTotalPages: 1,
      goalViewType: "charts",
      newPlan: false,
      newProposal: false,
      newPlansOfProposal: [],
      clientId: 0,
      tab: 1,
      disableForm: true,
      results: {},
      loading: true,
      message: null,
      idRegex: {
        required: true,
        regex: /(?<Year>[0-9][0-9])(?<Month>([0][1-9])|([1][0-2]))(?<Day>([0-2][0-9])|([3][0-1]))(?<Gender>[0-9])(?<Series>[0-9]{3})(?<Citizenship>[0-9])(?<Uniform>[0-9])(?<Control>[0-9])/,
      },
      goals: [],
      colors: [
        {
          class: "bluebg",
          graph: {
            fontColor: "white",
            axisColor: "white",
            axisGridColor: "grey",
            graphColor: "black",
            averageLineColor: "black",
            bottomScenarioLineColor: "red",
          },
        },
        {
          class: "whitebg",
          graph: {
            fontColor: "grey",
            axisColor: "grey",
            axisGridColor: "white",
            graphColor: "green",
            averageLineColor: "black",
            bottomScenarioLineColor: "red",
          },
        },
      ],
    };
  },
  methods: {
    updatePlanProposal(pl, event) {
      console.log("event", event);
      //  this.newPlansOfProposal.push(pl.id);
    },
    friendlyDate(arg, fmt) {
      if (fmt) return moment(arg, "YYYYMMDD").format(fmt);
      else return moment(arg).format("DD MMM YYYY HH:mm");
    },
    getImage(val) {
      var imageBaseUrl =
        "https://acportfoliolink.blob.core.windows.net/assets/";
      if (val.toLowerCase().includes("education"))
        return imageBaseUrl + "Education_32px.svg";
      else if (val.toLowerCase().includes("travel"))
        return imageBaseUrl + "Travel-Holiday_32px.svg";
      else if (val.toLowerCase().includes("retirement"))
        return imageBaseUrl + "Retirement_32px.svg";
      else if (val.toLowerCase().includes("emergency"))
        return imageBaseUrl + "Emergency_32px.svg";
    },
    async deleteGoal(clientId, id) {
      const response = await deleteClientGoalsV2({
        clientId: clientId,
        id: id,
      });
      if (response) {
        this.getResults(this.pageNr);
      }
    },
    showNewPlan(val) {
      this.newPlan = val;
    },
    editClick: function() {
      this.disableForm = !this.disableForm;
    },
    formatNr(val, fmt) {
      if (fmt) return numeral(val).format(fmt);
      else return numeral(val).format("0,0.0a");
    },
    async saveClick() {
      this.disableForm = !this.disableForm;
      var response = await createClient({
        clientView: {
          id: this.results.id,
          partnerId: this.$store.state.partnerId,
          firstName: this.results.firstName,
          primaryEmail: this.results.primaryEmail,
          mobile: this.results.mobile,
          middleName: this.results.middleName,
          lastName: this.results.lastName,
          idNumber: this.results.idNumber,
          birthdaySk: this.results.birthdaySk,
        },
      });
      this.message = "Success";
    },
    async createProposal() {
      var goalIds = [];
      for (var i = 0; i < this.goals.length; i++) {
        goalIds.push(this.goals[i].id);
      }
      var response = await createProposalsV2({
        clientId: this.$route.params.id,
        goalIds: goalIds,
	      appName: this.$store.state.appName
      });
      this.message = "Success";
    },
    async getResults(pageNr) {
      this.loading = true;
      this.pageNr = pageNr;
      var response = await getClient({
        id: this.$route.params.id,
      });
      var response2 = await getClientGoalsV2({
        clientId: this.$route.params.id,
        pageNr: pageNr,
      });
      //console.log(response2);
      if (response2) {
        this.results = response.result;
        this.goals = response2.result;
        this.goalsTotalPages = response2.totalPages;
        this.goalsTotalRecords = response2.totalRecords;
        this.loading = false;
      }
      // load client goals
    },
  },
  async mounted() {
    const partnerSettingsResponse = await getPartnerSettings();
    if (partnerSettingsResponse) {
      this.appearanceSettings =
        partnerSettingsResponse.partnerDefaultSettings.appearanceSettings;
      console.log("this.appearanceSettings", this.appearanceSettings);
      this.clientId = this.$route.params.id;
      this.getResults(1);
    }
  },
};
</script>
<style lang="css" scoped></style>
